import { render, staticRenderFns } from "./LongTextInput.component.vue?vue&type=template&id=6bebc35c&scoped=true&"
import script from "./LongTextInput.component.vue?vue&type=script&lang=js&"
export * from "./LongTextInput.component.vue?vue&type=script&lang=js&"
import style0 from "./LongTextInput.component.vue?vue&type=style&index=0&id=6bebc35c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bebc35c",
  null
  
)

export default component.exports